// extracted by mini-css-extract-plugin
module.exports = {"extension-table":"extensions-info-component-module__ULIy3W__extension-table"};